<!-- ======= About Section ======= -->
<section id="about" class="about animated fadeIn">
  <div class="container">

    <div class="row justify-content-between pt-5">
      <div class="col-lg-5 d-flex align-items-center justify-content-center about-img">
        <img src="assets/img/about.png" class="img-fluid" alt="" data-aos="zoom-in" style="margin-top: -55px">
      </div>
      <div class="col-lg-6 pt-5 pt-lg-0">
        <h3 data-aos="fade-up">Trabajo y tesón</h3>
        <p data-aos="fade-up" data-aos-delay="100">
          Desde nuestros modestos comienzos, a finales de los años 50, en la ciudad de Burgos, España, pasando por Reino Unido y la Costa del Sol malagueña en el presente, fijamos nuestra vista en San Juan y en el futuro. El trato directo posibilita mayor rentabilidad para nuestros clientes. Su satisfacción es nuestro mayor tesoro. Hemos presentado y ejecutado numerosos emprendimientos siempre centrados en nuestra pasión por la construcción. Los proyectos exitosamente terminados son una bandera que permanece. Y ahora en San Juan. Para más información sobre Loteo Don Emilio no dude en contactarnos.
        </p>
      </div>
    </div>

  </div>
</section><!-- End About Section -->
